import { TSignUpFields, TUser } from 'shared/types'
import { api } from '../api'

export const register = (data: TSignUpFields) =>
  api.post<TUser>('/v1/accounts/sign-up', data)
